import {
  PurchaseContractsDueForInvoicingFilters,
  SalesContractsDueForInvoicingFilters,
} from './_state';

export class SetSalesContractsDueForInvoicingListConfig {
  static readonly type = '[Sales Contracts Due For Invoicing] Set List Config';
  constructor(
    public config: {
      itemsPerPage: number;
      searchText?: string;
      salesFilters?: SalesContractsDueForInvoicingFilters;
    },
  ) {}
}

export class SetPurchaseContractsDueForInvoicingListConfig {
  static readonly type = '[Purchase Contracts Due For Invoicing] Set List Config';
  constructor(
    public config: {
      itemsPerPage: number;
      searchText?: string;
      purchaseFilters?: PurchaseContractsDueForInvoicingFilters;
    },
  ) {}
}
